
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93aX6vqwsWdHMeta } from "/codebuild/output/src239773520/src/gx-booking/pages/[...slug].vue?macro=true";
import { default as _404TkvA3A0DKjMeta } from "/codebuild/output/src239773520/src/gx-booking/pages/404.vue?macro=true";
import { default as _91_91filter_93_93vAzot2Yt5IMeta } from "/codebuild/output/src239773520/src/gx-booking/pages/account/bookings/[[filter]].vue?macro=true";
import { default as indexHz0kL9bAV1Meta } from "/codebuild/output/src239773520/src/gx-booking/pages/account/index.vue?macro=true";
import { default as notificationsVOBtNimkzXMeta } from "/codebuild/output/src239773520/src/gx-booking/pages/account/notifications.vue?macro=true";
import { default as paymentsVVjVBrUhfEMeta } from "/codebuild/output/src239773520/src/gx-booking/pages/account/payments.vue?macro=true";
import { default as personal_45infoFc6rDw3noHMeta } from "/codebuild/output/src239773520/src/gx-booking/pages/account/personal-info.vue?macro=true";
import { default as securityPrpb1hgyfQMeta } from "/codebuild/output/src239773520/src/gx-booking/pages/account/security.vue?macro=true";
import { default as confirmz8fvybHJolMeta } from "/codebuild/output/src239773520/src/gx-booking/pages/experiences/[parentId]/[serviceId]/confirm.vue?macro=true";
import { default as indexy42pGKOUs7Meta } from "/codebuild/output/src239773520/src/gx-booking/pages/experiences/[parentId]/[serviceId]/index.vue?macro=true";
import { default as _91bookingId_93pU1xjSHOUNMeta } from "/codebuild/output/src239773520/src/gx-booking/pages/experiences/[parentId]/[serviceId]/return/[bookingId].vue?macro=true";
import { default as _91accessKey_93p0O5kftHb1Meta } from "/codebuild/output/src239773520/src/gx-booking/pages/gratuity/[accessKey].vue?macro=true";
import { default as loginFWK5EXDtMMMeta } from "/codebuild/output/src239773520/src/gx-booking/pages/login.vue?macro=true";
import { default as _91code_93uYL5QZOh1LMeta } from "/codebuild/output/src239773520/src/gx-booking/pages/referral/[code].vue?macro=true";
import { default as reset_45passwordGivvMl5jj6Meta } from "/codebuild/output/src239773520/src/gx-booking/pages/reset-password.vue?macro=true";
import { default as set_45passwordMLN2v4BRRrMeta } from "/codebuild/output/src239773520/src/gx-booking/pages/set-password.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93aX6vqwsWdHMeta || {},
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/[...slug].vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/404.vue")
  },
  {
    name: "account-bookings-filter",
    path: "/account/bookings/:filter?",
    meta: _91_91filter_93_93vAzot2Yt5IMeta || {},
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/account/bookings/[[filter]].vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexHz0kL9bAV1Meta || {},
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/account/index.vue")
  },
  {
    name: "account-notifications",
    path: "/account/notifications",
    meta: notificationsVOBtNimkzXMeta || {},
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/account/notifications.vue")
  },
  {
    name: "account-payments",
    path: "/account/payments",
    meta: paymentsVVjVBrUhfEMeta || {},
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/account/payments.vue")
  },
  {
    name: "account-personal-info",
    path: "/account/personal-info",
    meta: personal_45infoFc6rDw3noHMeta || {},
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/account/personal-info.vue")
  },
  {
    name: "account-security",
    path: "/account/security",
    meta: securityPrpb1hgyfQMeta || {},
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/account/security.vue")
  },
  {
    name: "experiences-parentId-serviceId-confirm",
    path: "/experiences/:parentId()/:serviceId()/confirm",
    meta: confirmz8fvybHJolMeta || {},
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/experiences/[parentId]/[serviceId]/confirm.vue")
  },
  {
    name: "experiences-parentId-serviceId",
    path: "/experiences/:parentId()/:serviceId()",
    meta: indexy42pGKOUs7Meta || {},
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/experiences/[parentId]/[serviceId]/index.vue")
  },
  {
    name: "experiences-parentId-serviceId-return-bookingId",
    path: "/experiences/:parentId()/:serviceId()/return/:bookingId()",
    meta: _91bookingId_93pU1xjSHOUNMeta || {},
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/experiences/[parentId]/[serviceId]/return/[bookingId].vue")
  },
  {
    name: "gratuity-accessKey",
    path: "/gratuity/:accessKey()",
    meta: _91accessKey_93p0O5kftHb1Meta || {},
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/gratuity/[accessKey].vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginFWK5EXDtMMMeta || {},
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/login.vue")
  },
  {
    name: "referral-code",
    path: "/referral/:code()",
    meta: _91code_93uYL5QZOh1LMeta || {},
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/referral/[code].vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordGivvMl5jj6Meta || {},
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/reset-password.vue")
  },
  {
    name: "set-password",
    path: "/set-password",
    meta: set_45passwordMLN2v4BRRrMeta || {},
    component: () => import("/codebuild/output/src239773520/src/gx-booking/pages/set-password.vue")
  }
]